import styles from "./chatVideoPlayer.module.scss";
import React, { useEffect, useState } from "react";
import FilePreview from "../filePreview";
import { useSelector } from "react-redux";
import { chatwindowDetails, initialStateModel } from "../../../../models/model";
import store from "../../../../context/store/store";
import { updateOpenstate } from "../../../../base/socketChatService/utils";
type audioTypeProps = {
  data: any;
  fromContactSaved?: any;
  multiData?: any;
}
type videoMessageState = {
  pausePlay: any;
  duration: any;
  videoId: string;
  playerIndex:any;
}
type fileMessageState = {
  isOpen: boolean;
  id: any;
  dataRes: any;
}
export default function ChatVideoPlayer({ data, fromContactSaved, multiData }: audioTypeProps) {
  const messageBody = data && data?.message?.body;
  let { timestamp } = data;
  let indexId = data?.indexId !== undefined ? data?.indexId : timestamp;
  const [videoState, setvideoState] = useState<videoMessageState>({ pausePlay: false, duration: '00:00', videoId: "",playerIndex:1 });
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  //const [seektime, setseektime] = useState(0);
  //const [currentduration, setCurrentduration] = useState("00:00");
  const [fileState, setfileState] = useState<fileMessageState>({ isOpen: false, id: '', dataRes: '' });
  //let htimestamp = moment(timestamp).format('hh:mm A');
  let myVideo: any = document.getElementById(indexId);
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);

  let { messageList }: any = chatSocketMessage;
  let timeDuration: any;
  let duration = myVideo?.duration;
  let d = Number(duration);
  let h = Math.floor(d / 3600);
  let m = Math.floor(d % 3600 / 60);
  let s = Math.floor(d % 3600 % 60);

  let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
  let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
  let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
  timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;

  useEffect(() => {
    let myVideo: any = document.getElementById(indexId);
    let timeDuration: any;
    let duration = myVideo?.duration;
    let d = Number(duration);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    setvideoState({ ...videoState, duration: timeDuration });

    myVideo.addEventListener('pause', (event: any) => {
      let myVideo: any = document.getElementById(indexId);
      setvideoState({ ...videoState, pausePlay: false,playerIndex:Math.floor(myVideo?.currentTime)});
    });

    return () => {
      myVideo.removeEventListener('pause', (event: any) => {
      });
    };

  }, [timeDuration]);

  // const videoPlay = () => {
  //   try {
  //     var videos: any = document.querySelectorAll('.videoFluid');
  //     videos.forEach((element: any) => {
  //       if (element.pause) {
  //         element.pause();
  //       }
  //     });
  //     let video: any = document.getElementById(indexId);
  //     setvideoState({ ...videoState, pausePlay: !videoState.pausePlay});
  //     if (!videoState.pausePlay) {
  //       video.addEventListener("timeupdate", seektimeupdate, false);
  //       video?.play();
  //     }
  //     else {
  //       video?.pause();
  //     }
  //   }
  //   catch (e) {
  //     console.log("error is", e);
  //   }


  // };
  const previewopen = (data: any) => {
    setfileState({ ...fileState, isOpen: !fileState.isOpen, id: data?.id, dataRes: data });
   
    updateOpenstate(true)
  };

  // const player_Onchange = (val: number) => {
  //   let vid: any = document.getElementById(indexId);
  //   if(vid){
  //     vid.currentTime = val;
  //     setvideoState({ ...videoState, playerIndex: val });
  //   }
  // }

  // const seektimeupdate = () => {
  //   //let seekslider:any = document.getElementById("seekslider");
  //   let vid: any = document.getElementById(indexId);
  //   //var nt = vid.currentTime * (100 / vid.duration);
  //   //seekslider.value = nt;
  //   if(vid){
  //   setseektime(vid.currentTime)
  //   var curmins: any = Math.floor(vid.currentTime / 60);
  //   var cursecs: any = Math.floor(vid.currentTime - curmins * 60);
  //   var durmins: any = Math.floor(vid.duration / 60);
  //   var dursecs: any = Math.floor(vid.duration - durmins * 60);
  //   if (cursecs < 10) { cursecs = "0" + cursecs; }
  //   if (dursecs < 10) { dursecs = "0" + dursecs; }
  //   if (curmins < 10) { curmins = "0" + curmins; }
  //   if (durmins < 10) { durmins = "0" + durmins; }

  //   let currDuration = curmins + ":" + cursecs

  //   setCurrentduration(currDuration)
  //   if (currDuration === getduration(vid.duration) && videoState.pausePlay) {
  //     setvideoState({ ...videoState, pausePlay: false });
  //     vid.pause();
  //     //setCurrentduration('00:00')
  //     //setseektime(0);
  //   }
  // }
    
  // }

  // const getduration = (time: any) => {
  //   let timeDuration: any;
  //   let d = Number(time);
  //   let h = Math.floor(d / 3600);
  //   let m = Math.floor(d % 3600 / 60);
  //   let s = Math.floor(d % 3600 % 60);

  //   let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
  //   let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
  //   let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
  //   timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
  //   return timeDuration;
  // }
  const FilePreviewer = ()=>{
    setfileState({...fileState,isOpen:!fileState.isOpen});
  };
 
  return (
    <>
    {fileState.isOpen && <FilePreview isOpen={fileState.isOpen} data={fileState.dataRes}
              previewopen={FilePreviewer}  groupdata={messageList}/> }
      <div className={fromContactSaved ? `${styles.videoMsg} ${styles.contactvideosize}` : styles.videoMsg} >
        <video className="videoFluid" id={indexId} controls={false} autoPlay={false} preload="metadata" >
          <source src={messageBody?.filePath} type="video/mp4" />
          <div className={styles.videoOverlay}></div>
        </video>
        {/* <div className={styles.playerContainer}>
          <div className={styles.controlSmall}>
            <div className={styles.durationVideo}>{videoState.pausePlay ? currentduration : videoState.duration}</div>
          </div> */}
          {/* <div className={styles.videoProgress}>
                      <div className={styles.progressIndicator}></div>
                      <div className={styles.videoProgressFilled}></div>
                    </div> */}
                    {/* min={1} max={videoState.playerIndex} onChange={player_Onchange}*/}
          {/* <Slider defaultValue={0} value={seektime} tooltipVisible={false}  
          min={0} max={Math.round(duration)} onChange={player_Onchange}
              className="videoSlider" 
            />
        </div> */}
        <div className={videoState.pausePlay ? styles.pauseIcon : styles.playIcon}
         onClick={()=>previewopen(data)}
        >
        </div>
        {/* <div className={styles.attachmentHover} id={"hover" + id}>
          <ChatAttachmentsOption data={data} overAllFileData={data} fromFiles={false} previewopen={previewopen} hoverdata={Array.isArray(multiData) && multiData?.length > 0 && multiData[0]} />
        </div> */}
      </div>

    </>
  );
};
